<template>
    <div id='basicControls' v-if="showSelf" :style="panelStyle">
        <div class="basicControls-title">病害类型</div>
        <div class="panel-bad">
            <ul class="panel-top clear">
                <li v-for="(item,index) in badList" class="bad-img" :style="'background-image:url('+item.img+')'" :title="item.name" @click="drawRoadDefect(index,item.id,item.lv)"></li>
            </ul>
        </div>
    </div>
</template>
<script> 
    import {DefectControlCommand} from './commands/DefectControlCommand.js'
    export default{
        name:'BadControlPanel',
        data(){
            return {
               showSelf:false,
               panelStyle: 'top:30px;right:10px;', 
               badList:[{
                  id:1,
                  name:'龟裂#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a1L.png'
               },{
                  id:1,
                  name:'龟裂#M',
                  lv:2,
                  img:'static/bimroad/imgs/iconImg/a1M.png'
               },{
                  id:1,
                  name:'龟裂#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a1H.png'
               },{
                  id:2,
                  name:'块状裂缝#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a2L.png'
               },{
                  id:2,
                  name:'块状裂缝#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a2H.png'
               },{
                  id:3,
                  name:'纵向裂缝#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a3L.png'
               },{
                  id:3,
                  name:'纵向裂缝#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a3H.png'
               },{
                  id:4,
                  name:'横向裂缝#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a4L.png'
               },{
                  id:4,
                  name:'横向裂缝#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a4H.png'
               },{
                  id:5,
                  name:'坑槽#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a5L.png'
               },{
                  id:5,
                  name:'坑槽#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a5H.png'
               },{
                  id:6,
                  name:'松散#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a6L.png'
               },{
                  id:6,
                  name:'松散#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a6H.png'
               },{
                  id:7,
                  name:'沉陷#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a7L.png'
               },{
                  id:7,
                  name:'沉陷#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a7H.png'
               },{
                  id:8,
                  name:'车辙#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a8L.png'
               },{
                  id:8,
                  name:'车辙#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a8H.png'
               },{
                  id:9,
                  name:'波浪拥包#L',
                  lv:1,
                  img:'static/bimroad/imgs/iconImg/a9L.png'
               },{
                  id:9,
                  name:'波浪拥包#H',
                  lv:3,
                  img:'static/bimroad/imgs/iconImg/a9H.png'
               },{
                  id:10,
                  name:'泛油',
                  lv:'',
                  img:'static/bimroad/imgs/iconImg/a10.png'
               },{
                  id:11,
                  name:'块状修补',
                  lv:'',
                  img:'static/bimroad/imgs/iconImg/a11.png'
               },{
                  id:12,
                  name:'横向裂缝修补',
                  lv:'',
                  img:'static/bimroad/imgs/iconImg/a12.png'
               },{
                  id:13,
                  name:'纵向裂缝修补',
                  lv:'',
                  img:'static/bimroad/imgs/iconImg/a13.png'
               },{
                  id:14,
                  name:'唧浆',
                  lv:'',
                  img:'static/bimroad/imgs/iconImg/a14.png'
               }],
               permissions:[]
            }
        },
        created(){

        },
        mounted(){
          
        },
        methods:{
            drawRoadDefect(index,badType,badLv){
                var eventArg = {'command': new DefectControlCommand(2, this, index,{type:'roadBad',id:'',panel:true,badType:badType,lv:badLv,})};
                this.$emit("controlBadCommand", eventArg); 
            },
            adjStyle(style){
                this.panelStyle=  style;
            }
        }
    }
</script>
<style lang='less' scoped>
    @import '../../assets/css/common.less';
    @import '../../assets/css/mixin.less';
    #basicControls{
        position:absolute;
        width: 188px;
        box-sizing: border-box;
        border: 1px solid #14171c;
        background: linear-gradient(0deg,#1e202a,#0d1013);
        box-shadow: inset 0 0 0 1px #575757, 0 2px 21px 0 rgba(33,34,39,.55);
        opacity: .85;
        border-radius: 2px;
        z-index:200;
        .sc(14px,#fff);
        .basicControls-title{
          .wh(100%,40px);
          line-height:40px;
          text-align: center;
          border-bottom:1px dotted #505050;
        }
        .panel-bad{
            width:188px;
            .panel-top{
                padding:15px 0 0 15px;
                .bad-img{
                   .wh(30px,30px);
                   background-size:cover;
                   background-repeat:no-repeat;
                   background-position:center center;
                   margin-right:13px;
                   float:left;
                   margin-bottom:13px;
                   &:nth-of-type(4n){
                      margin-right:0;
                   }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/BadControlPanel.vue